module.exports = __webpack_public_path__ + "img/golf.4c96a557.png";